import { Inject, Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ProgressComponent } from '../components/progress/progress.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private static service: MatSnackBar | undefined = undefined;
  private static loaderRef: any = undefined;

  public constructor(@Inject(MatSnackBar) service: MatSnackBar) {
    LoaderService.service = service;
  }

  public static getService(): MatSnackBar {
    if (!LoaderService.service) {
      throw new Error('LoaderService not initialized');
    }
    return LoaderService.service;
  }

  public static showFromComponent(options: any) {
    LoaderService.loaderRef = LoaderService.getService().openFromComponent(
      ProgressComponent,
      options,
    );
  }

  public static dismiss() {
    if (LoaderService.loaderRef) {
      LoaderService.loaderRef.dismiss();
      LoaderService.loaderRef = undefined;
    }
  }
}
